module.exports = __webpack_public_path__ + "img/bm-1.9ba705c9.png";